import { render, staticRenderFns } from "./DotLloader.vue?vue&type=template&id=3914cf60&scoped=true"
import script from "./DotLloader.vue?vue&type=script&lang=js"
export * from "./DotLloader.vue?vue&type=script&lang=js"
import style0 from "./DotLloader.vue?vue&type=style&index=0&id=3914cf60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3914cf60",
  null
  
)

export default component.exports